import React from "react";
import CountUp from "../../components/CountUp";
import WorldMap from "../../assets/institution/WorldMap.png";
import SectionsTitle from "../Components/SectionsTitle";

const infoData = [
  {
    title: "Countries",
    count: 5,
    delay: 100,
    duration: 2000,
  },
  {
    title: "Institutions",
    count: 100,
    delay: 200,
    duration: 2000,
  },
  {
    title: "Programs",
    count: 4000,
    delay: 300,
    duration: 2000,
  },
  {
    title: "Students",
    count: 5000,
    delay: 400,
    duration: 2000,
  },
];

export default function Main() {
  return (
    <div className="m-4">
      <SectionsTitle title={"Connecting global partners and institutions"} />
      <div className="row justify-content-center align-items-center mt-5">
        <div className="col-2">
          <div>
            {infoData.map((item, index) => (
              <div
                className="aos-init aos-animate my-auto"
                data-aos="zoom-in-left"
                data-aos-delay={item.delay}
                key={index}
              >
                <div className="py-4">
                  <div className="text3 fw-bold ">
                    <CountUp
                      start={0}
                      end={item.count}
                      duration={item.duration}
                      suffix={"+"}
                    />
                  </div>
                  <div className="text2">{item.title}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="col-10">
          <img src={WorldMap} alt={"WorldMap"} className="img-fluid" />
        </div>
      </div>
    </div>
  );
}
